import { Dialog } from '@mui/material';
import { IconX } from '@tabler/icons-react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import { Button, IconButton } from 'ui';

import { RECOMMENDED_TASK_STATUS } from '../../core/constants';

const MessageModal = ({ open, onClose, task, onComplete }) => {
  if (!task) return null;

  const handleDismiss = () => {
    onComplete(task.taskId);
    onClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={onClose}
      sx={{ '.MuiPaper-root': { padding: 0, margin: 0, borderRadius: '1rem', width: '100%' } }}
    >
      <div className="relative flex w-full max-w-lg flex-col bg-white-100 p-6">
        <div className="mb-4 flex items-start justify-between">
          <div>
            <h3 className="text-xl font-semibold">{task.messageTitle || task.description}</h3>
            <p className="mb-2 text-sm text-gray-500">
              Received&nbsp;{format(task.createdAt * 1000, "d MMM yyyy 'at' h:mm a")}
            </p>
          </div>
          <IconButton
            Icon={<IconX size={20} className="text-gray-400" />}
            srOnly="Close"
            onClick={onClose}
            color="transparent"
          />
        </div>

        <div className="mb-6 whitespace-pre-wrap text-base text-gray-800">{task.messageBody}</div>

        <div className="flex justify-end gap-3">
          <Button title="Close" onClick={onClose} />
          {task.status === RECOMMENDED_TASK_STATUS.pending && (
            <Button title="Dismiss" color="primary" onClick={handleDismiss} />
          )}
        </div>
      </div>
    </Dialog>
  );
};

MessageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  task: PropTypes.object,
  onComplete: PropTypes.func.isRequired,
};

export default MessageModal;
